<script>
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { onDestroy, onMount } from "svelte";
	import { navigate, useLocation } from "svelte-routing";
	import { errorMessage, loading, masterData } from "../../../../store/store";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";
	import CustomSearch from "src/components/CustomSearch/CustomSearch.svelte";
	import {
		carMake,
		carModel,
		carType,
		resetFields,
		vehicleMakeForm,
	} from "src/validators/VehicleMake";
	import { optionFinder, usePopstate } from "src/utils/misc";
	import CustomButton from "src/components/CustomButton/CustomButton.svelte";
	import { addVehicleModel, editVehicleModel } from "src/services/vehicle";
	import ErrorMessageHandler from "src/components/ErrorMessageHandler/ErrorMessageHandler.svelte";

	let carModelError = "";
	let location = useLocation();
	let vehicleMakes = renderVehicleMakes();
	let vehicleTypes = renderVehicleTypes();
	let id = "";

	export let isEdit = true;

	const handleSubmit = async () => {
		try {
			loading.set(true);
			let res;
			const payload = {
				name: $carModel.value,
				vehicleMakeID: $carMake.value.value,
				vehicleTypeID: $carType.value.value,
			};

			if (isEdit) {
				res = await editVehicleModel({ id, ...payload });
			} else {
				res = await addVehicleModel(payload);
			}

			if (res?.status === 200) {
				resetFields();
				navigate("/master-data/vehicle-data/vehicle-model");
			} else {
				loading.set(false);
				carModelError = res.data.message;
			}
			loading.set(false);
		} catch (error) {
			loading.set(false);
			carModelError = error.response.data.message;
		}
	};

	function renderVehicleMakes() {
		return $masterData.vehicleMakes.map((make) => ({
			label: make.name,
			value: make.id,
		}));
	}

	function renderVehicleTypes() {
		return $masterData.vehicleTypes.map((type) => ({
			label: type.name,
			value: type.id,
		}));
	}

	const cleanup = usePopstate(() => {
		resetFields();
	});

	onMount(() => {
		resetFields();
		if (isEdit) {
			id = $location.state.id;
			$carMake.value = optionFinder(vehicleMakes, $location.state.makeId);
			$carType.value = optionFinder(vehicleTypes, $location.state.typeId);
			$carModel.value = $location.state.name;
		}
	});

	onDestroy(() => {
		resetFields();
		cleanup();
	});
</script>

<ErrorMessageHandler message={$errorMessage} />
<Col xs={6}>
	<Col xs={12}>
		<div>
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Vehicle Make Data" />
			</Col>
		</div>
	</Col>
	<Col xs={12} class="my-3">
		<div>
			<h5><b>{isEdit ? "Edit" : "Add"} Vehicle Model</b></h5>
		</div>
		<div>
			<p>*Mandatory fields</p>
		</div>
	</Col>
	<Col>
		<Row>
			<Col>
				<label for="mobile" class="d-block">
					<span> Vehicle Model* </span>
				</label>
			</Col>
		</Row>
		<Row>
			<Col xs={6}>
				<CustomInput
					type="text"
					bind:value={$carModel.value}
					error={$vehicleMakeForm.hasError("carModel.required") ||
						carModelError}
					errorText={$vehicleMakeForm.hasError("carModel.required")
						? "Vehicle model is required"
						: carModelError
							? carModelError
							: ""}
				/>
			</Col>
		</Row>
	</Col>
	<Col>
		<Row>
			<Col>
				<label for="priority" class="d-block pt-2">
					<span> Vehicle Make* </span>
				</label>
			</Col>
		</Row>
		<Row>
			<Col xs={6}>
				<CustomSearch
					isSearchable={false}
					items={vehicleMakes}
					placeholder="Select Vehicle Make"
					bind:value={$carMake.value}
					error={$vehicleMakeForm.hasError("carMake.required")}
					errorText="Vehicle make is required"
				/>
			</Col>
		</Row>
	</Col>
	<Col>
		<Row>
			<Col>
				<label for="priority" class="d-block pt-2">
					<span> Vehicle Type* </span>
				</label>
			</Col>
		</Row>
		<Row>
			<Col xs={6}>
				<CustomSearch
					isSearchable={false}
					items={vehicleTypes}
					placeholder="Select Vehicle Type"
					bind:value={$carType.value}
					error={$vehicleMakeForm.hasError("carType.required")}
					errorText="Vehicle type is required"
				/>
			</Col>
			<Col class="d-flex justify-content-start" xs={6}>
				<div class="mx-4 my-1">
					<CustomButton
						disabled={$loading ||
							!$vehicleMakeForm.valid ||
							!$carModel.value ||
							!$carMake.value}
						on:click={handleSubmit}
						buttonText={isEdit ? "Edit" : "Add"}
						color="primary"
					/>
				</div>
			</Col>
		</Row>
	</Col>
</Col>
